export default "__VITE_ASSET__c4856319__"